// src/api/aics/deploy.js
import { http } from "../base";

/**
 * 发布知识库（异步）
 * @param {Object} data - 发布请求参数
 * @param {number} data.tenantId - 租户ID
 * @param {string} data.mainWorkspaceSlug - 主工作区slug
 * @param {string} data.blueWorkspaceSlug - 蓝环境slug
 * @param {string} data.greenWorkspaceSlug - 绿环境slug
 * @param {number} data.docCount - 文档数量
 * @returns {Promise}
 */
export async function publishDeployTask(data) {
  console.log("publishDeployTask", data);

  const response = await http.post(
    `/aics/deploy/task/publish`,
    {
      'tenant_id': data.tenantId,
      'mainWorkspace_slug': data.mainWorkspaceSlug,
      'blueWorkspace_slug': data.blueWorkspaceSlug,
      'greenWorkspace_slug': data.greenWorkspaceSlug,
      'doc_count': data.docCount,
    },
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
  console.log("publishDeployTask, response.data",response.data);
  if (response.data == null || response.data.code !== 200) {
    throw new Error(response.data?.message || '发布知识库失败');
  }
  return response.data;
}

/**
 * 获取租户的发布任务列表（分页）
 * @param {number} tenantId - 租户ID
 * @param {Object} params - 分页参数
 * @param {number} params.pageNum - 页码（从1开始）
 * @param {number} params.pageSize - 每页条数
 * @returns {Promise}
 */
export async function getDeployTaskList(tenantId, params) {
  console.log("getDeployTaskList", tenantId, params);

  const response = await http.get(
    `/aics/deploy/task/list/${tenantId}`,
    {
      params: {
        pageNum: params?.pageNum || 1,
        pageSize: params?.pageSize || 10
      },
      headers: { 'Content-Type': 'application/json' }
    }
  );
  console.log(response.data);
  if (response.data == null || response.data.code !== 200) {
    throw new Error(response.data?.message || '获取发布任务列表失败');
  }
  return response.data;
}

/**
 * 获取单个发布任务的详情
 * @param {string} taskId - 任务ID
 * @returns {Promise}
 */
export async function getDeployTaskDetail(taskId) {
  console.log("getDeployTaskDetail", taskId);

  const response = await http.get(
    `/aics/deploy/task/${taskId}`,
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
  console.log(response.data);
  if (response.data == null || response.data.code !== 200) {
    throw new Error(response.data?.message || '获取任务详情失败');
  }
  return response.data;
}

/**
 * 获取运行中的发布任务数量（用于按钮红点）
 * @param {number} tenantId - 租户ID
 * @returns {Promise} - 返回 { code, data: number }
 */
export async function getRunningDeployTaskCount(tenantId) {
  console.log("getRunningDeployTaskCount", tenantId);

  const response = await http.get(
    `/aics/deploy/task/running/count/${tenantId}`,
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
  console.log("/aics/deploy/task/running/count/", response);
  if (response == null || response.data.code !== 200) {
    throw new Error(response.message || '获取运行中任务数量失败');
  }
  return response.data;
}

/**
 * 重试失败的任务
 * @param {string} taskId - 任务ID
 * @returns {Promise}
 */
export async function retryDeployTask(taskId) {
  console.log("retryDeployTask", taskId);

  const response = await http.post(
    `/aics/deploy/task/${taskId}/retry`,
    {},
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
  console.log(response.data);
  if (response.data == null || response.data.code !== 200) {
    throw new Error(response.data?.message || '重试任务失败');
  }
  return response.data;
}

/**
 * 取消正在执行的任务
 * @param {string} taskId - 任务ID
 * @returns {Promise}
 */
export async function cancelDeployTask(taskId) {
  console.log("cancelDeployTask", taskId);

  const response = await http.post(
    `/aics/deploy/task/${taskId}/cancel`,
    {},
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
  console.log(response.data);
  if (response.data == null || response.data.code !== 200) {
    throw new Error(response.data?.message || '取消任务失败');
  }
  return response.data;
}